import { IWbThemeColors } from '../../../types/api-response/auth/website-builder';

export const defaultWbThemeColors: IWbThemeColors = {
    backgroundColor: '#021F36',
    primaryColor: '#03192B',
    textColor: '#d3d3d3',
    titleTextColor: '#d3d3d3',
};



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/classes/theme.ts